export const getSlug = title => {
  return title.trim().replace(/\s/g, "-").toLowerCase()
}
